<dx-select-box
  valueExpr="field"
  label="{{ 'Feld' | translate }}"
  width="100%"
  placeholder="{{ 'Feld auswählen' | translate }}"
  [displayExpr]="getFieldDisplayExpr"
  [showClearButton]="true"
  [items]="fieldList"
  [searchEnabled]="true"
  [(value)]="pimField.field"
  (onSelectionChanged)="update()"
/>

<dx-number-box
  class="flex-grow-1 np-highlight"
  label="{{ 'Preisliste Sortiernummer' | translate }}"
  [value]="parseInt(pimField.systemKey)"
  (onValueChanged)="onOrderChanged()"
></dx-number-box>

<dx-number-box
  *ngIf="needsElement"
  class="flex-grow-1 np-highlight"
  label="{{ 'Preis Sortiernummer' | translate }}"
  [value]="parseInt(pimField.elementKey)"
  (onValueChanged)="onOrderChanged()"
></dx-number-box>
